import { selectFilterSpec } from '@ow/utils'

export { selectFilterSpec as filterSpec }
export const config = {
  etc: true,
  hint: '请输入',
  slug: `cascader${Math.round(Math.random() * 100)}`,
  type: 'cascader',
  title: '级联选择',

  remote: 'https://node-hnapi.herokuapp.com/news',
  selects: [],
  multiple: false,
  readonly: false,
  required: false,
  description: '备注显示区域：进行详细的解释说明。',
  hiddenWhenCreate: true,
  showType: 'show',
}
